import { useState } from "react";
import { Link } from "react-router-dom";
import { MinusIcon, PlusIcon } from "../../../assets/svg/ProuductIcons";

const MobileNavMenu = ({ categoryData, collectionData }) => {
  const [openMenus, setOpenMenus] = useState([]);

  const toggleSubMenu = (menu) => {
    setOpenMenus((prev) =>
      prev.includes(menu) ? prev.filter((m) => m !== menu) : [...prev, menu]
    );
  };

  return (
    <nav className="offcanvas-navigation" id="offcanvas-navigation">
      <ul className="drawer_links_con">
        <li>
          <Link to="/AboutUs" className="mobile_menu_item is_link">
            About
          </Link>
        </li>

        {/* jewelry menu */}
        <li
          className={`submenu_main_con ${
            openMenus.includes("jewelry") ? "active" : ""
          }`}
        >
          <button
            className="mobile_menu_item submenu-toggle"
            onClick={() => toggleSubMenu("jewelry")}
          >
            <span>Jewelry</span>
            <span className="icon_con">
              <PlusIcon className="plus_icon" />
              <MinusIcon className="minus_icon" />
            </span>
          </button>
          <div className="submenu_inner_con">
            <div className="submenu_overflow_con">
              <ul>
                {categoryData?.Data &&
                  categoryData.Data.map((category, index) => (
                    <li key={index}>
                      <Link
                        to={`/category/${category.GatiCategoryId}`}
                        className="is_link"
                      >
                        {category.DesgGroupName}
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </li>

        {/* Collection menu */}
        <li
          className={`submenu_main_con ${
            openMenus.includes("collection") ? "active" : ""
          }`}
        >
          <button
            className="mobile_menu_item submenu-toggle"
            onClick={() => toggleSubMenu("collection")}
          >
            <span>Collection</span>
            <span className="icon_con">
              <PlusIcon className="plus_icon" />
              <MinusIcon className="minus_icon" />
            </span>
          </button>
          <div className="submenu_inner_con">
            <div className="submenu_overflow_con">
              <ul>
                {collectionData?.Data &&
                  collectionData.Data.map((item, index) => (
                    <li key={index}>
                      <Link
                        to={`/collection/${item.GatiCategoryId}`}
                        className="is_link"
                      >
                        {item.DesgGroupName}
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </li>
        <li>
          <Link to="/expertise" className="mobile_menu_item is_link">
            Expertise
          </Link>
        </li>
        {/* <li>
          <Link to="/media" className="mobile_menu_item is_link">
            Media
          </Link>
        </li> */}
        <li>
          <Link to="/ContactUs" className="mobile_menu_item is_link">
            Contact
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default MobileNavMenu;
